import type { ReactNode } from 'react';

import { BaseMap } from '@/components/map/BaseMap';
import { MapMenu } from '@/components/map/MapMenu';
import { ReportsLayer } from '@/components/report/map/ReportsLayer';

interface ReportMapProps {
  children: ReactNode;
}

export function PublicMap({ children }: ReportMapProps) {
  return (
    <BaseMap style={{ flex: 1, minHeight: '100%' }}>
      <MapMenu />

      <ReportsLayer
        fitBoundsHorizontalPaddingFactor={0.35}
        data={`/features/collections/public.report_view/items.json?${new URLSearchParams({
          properties: ['id', 'status', 'category'].join(','),
        })}`}
      />

      {children}
    </BaseMap>
  );
}
